import { Show, createSignal } from 'solid-js';
import { ApiError, api, errMsg, setAdminPassword } from '../lib/api';
import { Button } from '../ui/Button';
import { Card } from '../ui/Card';
import { ErrorText } from '../ui/ErrorText';
import { Input } from '../ui/Input';
import { Label } from '../ui/Label';

type Props = {
  onAuthed: () => void;
};

export function Login(props: Props) {
  const [pw, setPw] = createSignal('');
  const [err, setErr] = createSignal<string | null>(null);
  const [busy, setBusy] = createSignal(false);

  async function submit(e: Event) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      await api('/auth/check', {}, pw());
      setAdminPassword(pw());
      props.onAuthed();
    } catch (cause) {
      setErr(
        cause instanceof ApiError && cause.status === 401
          ? 'Wrong password.'
          : errMsg(cause),
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <Card>
      <form
        onSubmit={submit}
        class="flex flex-col gap-3"
        aria-label="Admin login"
      >
        <div class="flex flex-col gap-1">
          <Label for="admin-password">Admin password</Label>
          <Input
            id="admin-password"
            type="password"
            autocomplete="current-password"
            value={pw()}
            onInput={(e) => setPw(e.currentTarget.value)}
            aria-invalid={err() ? 'true' : undefined}
            aria-describedby={err() ? 'admin-password-error' : undefined}
            autofocus
          />
        </div>
        <div class="flex items-center gap-3">
          <Button kind="primary" type="submit" disabled={busy() || !pw()}>
            {busy() ? 'Checking…' : 'Continue'}
          </Button>
          <Show when={err()}>
            <ErrorText id="admin-password-error">{err()}</ErrorText>
          </Show>
        </div>
      </form>
    </Card>
  );
}
